import { Injectable } from '@angular/core';

import { AppConfigService } from '@alfresco/adf-core';

import { NODE_CONSTANT } from '../model/alf-model';
import { CONSTANTS } from '../model/custom-adf-model';
import { Node } from '@alfresco/js-api';
import { SiteConfig, UploadTypeConfig } from '../types';

@Injectable({
  providedIn: 'root',
})
export class SiteConfigService {
  siteObject: any;
  selectedNodeType = [];
  constructor(private readonly appConfigService: AppConfigService) {}

  getCurrentSiteObject(currentSite: string): SiteConfig {
    this.siteObject = this.appConfigService.get<SiteConfig[]>('sites');
    return this.getCurrentSite(this.siteObject, currentSite);
  }

  getCurrentSite(
    siteConfiguration: Array<SiteConfig>,
    currentSite: string,
    defaultSite = 'default-site'
  ): SiteConfig {
    return (
      siteConfiguration.find((site) => site.id === currentSite) ||
      siteConfiguration.find((site) => site.id === defaultSite)
    );
  }

  getNodeTypeForSearch(currentSite, docType) {
    const siteObject = this.getCurrentSiteObject(currentSite);
    docType = docType.toLowerCase();
    return siteObject.upload.documentLibrary[docType].nodeType;
  }

  getCurrentFolder(directoryName: Node) {
    if (
      directoryName.properties[NODE_CONSTANT.SITE_COMPONENT_ID] ===
        CONSTANTS.DOCUMENT_LIBRARY ||
      directoryName.path.name.includes(CONSTANTS.DOCUMENT_LIBRARY)
    ) {
      return CONSTANTS.DOCUMENT_LIBRARY;
    }
    if (
      directoryName.properties[NODE_CONSTANT.SITE_COMPONENT_ID] ===
        CONSTANTS.EMAIL_TEMPLATES ||
      directoryName.path.name.includes(CONSTANTS.EMAIL_TEMPLATES)
    ) {
      return CONSTANTS.EMAIL_TEMPLATES;
    }
    if (
      directoryName.properties[NODE_CONSTANT.SITE_COMPONENT_ID] ===
        CONSTANTS.CONTENT_TEMPLATES ||
      directoryName.path.name.includes(CONSTANTS.CONTENT_TEMPLATES)
    ) {
      return CONSTANTS.CONTENT_TEMPLATES;
    }
    return CONSTANTS.CONTRACT_TEMPLATES;
  }

  getCurrentSelection(currentSite: string, directoryName: Node, type: string) {
    type = type.toLowerCase();
    const siteObject = this.getCurrentSiteObject(currentSite);
    const currentFolder = this.getCurrentFolder(directoryName);
    this.setPathIfConfigured(
      siteObject.upload[currentFolder][type],
      siteObject
    );
    return siteObject.upload[currentFolder][type];
  }

  setPathIfConfigured(
    configType: UploadTypeConfig,
    currentSiteObj: SiteConfig = null,
    currentSite = ''
  ): void {
    if (!currentSiteObj) {
      currentSiteObj = this.getCurrentSiteObject(currentSite);
    }
    const ref = configType['ref'];
    if (!configType['fts_path'] && ref) {
      const path = ref
        .split('.')
        .reduce((obj, key) => obj[key], currentSiteObj);
      configType['fts_path'] = path;
    }
  }

  getFolderObject(currentSite: string, directoryName: Node) {
    const siteObject = this.getCurrentSiteObject(currentSite);
    const currentFolder = this.getCurrentFolder(directoryName);
    return Object.values(siteObject.upload[currentFolder]);
  }
}
